import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import LabelButton from "../../components/reusable-components/buttons/LabelButton";
import InnoTextInput from "../../components/inputs/InnoTextInput";
import { useValidation } from "../../helpers/validationHelpers";
import TextBox from "../../components/inputs/TextBox";

const commonTypographyStyles = {
  fontFamily: "Lato",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "normal",
};

const primaryTypographyStyles = {
  ...commonTypographyStyles,
  color: "var(--Primary-500, #16124C)",
};

const secondaryTypographyStyles = {
  ...commonTypographyStyles,
  color: "var(--Secondary-500, #AC5CCC)",
};

export default function ResetPswdPage({ email, token }) {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [pswdErrorMsg, setPswdErrorMsg] = useState("");
  const [pswdHelpText, setPswdHelpText] = useState("");
  const { errors, validate } = useValidation({
    password: {
      is8OrMoreCharacters: true,
      hasCapitalLetter: true,
      hasLowercaseLetter: true,
      hasNumber: true,
      hasSymbol: true,
    },
  });

  //update the pswdHelpText
  useEffect(() => {
    if (password && !errors?.password?.isValid) {
      const pswdHelpMessageList = [
        { hasCapitalLetter: "Must contain at least one capital letter." },
        { hasLowercaseLetter: "Must contain at least one lowercase letter." },
        { hasSymbol: "Must contain at least one symbol." },
        { is8OrMoreCharacters: "Must be at least 8 characters." },
        { hasNumber: "Must contain at least one number." },
      ];
      const errorsList = Object.keys(errors.password?.errorMessages || {});

      const formatedText = (
        <List sx={{ paddingY: "1px" }}>
          {pswdHelpMessageList.map((msg, index) => {
            if (errorsList.includes(Object.keys(msg)[0])) {
              return pswdHelpTextList(index, Object.values(msg)[0], true);
            } else {
              return pswdHelpTextList(index, Object.values(msg)[0], false);
            }
          })}
        </List>
      );
      setPswdHelpText(formatedText);
    } else {
      setPswdHelpText("");
    }
  }, [errors?.password?.isValid]);

  const handleResetPswd = async() => {
    //if either password or confirm password is empty, then return error msg
    if (!password || !confirmPassword) {
      setPswdErrorMsg("Password can't be empty");
      return;
    }
    //if the password and confirm password not match each other, return error
    if (password !== confirmPassword) {
      setPswdErrorMsg("Passwords do not match");
      return;
    }
    //check if password validate
    let validForm = true;
    ["password"].forEach((input) => {
      validate(`${input}`, password);
      if (!errors[[input]].isValid) validForm = false;
    });
    if (!validForm) return;

    //set to api to update the pswd
    const res = await fetch("/auth/resetpassword", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token, password: password }),
    });

    if(!res.ok){
      const errorData = await res.json(); // Parse the JSON error response
      setPswdErrorMsg(
        errorData.error || "An error occurred. Please try again."
      );
      return;
    } else {
      //pswd reset, direct to autho universal login page
      window.location.href = `${
        process.env.REACT_APP_URL
      }/auth/email-login?email=${encodeURIComponent(email)}`;
    }
  };

  const handleToLoginPage = () => {
    window.location.href = `${
      process.env.REACT_APP_URL
    }/auth/email-login?email=${encodeURIComponent(email)}`;
  };


  const handleChange = (e, field) => {
    // for each field, set the value
    switch (field) {
      case "password":
        setPswdErrorMsg("");
        setPswdHelpText("");
        setPassword(e.target.value);
        // if (hasHitSubmit) validate(field, e.target.value);
        break;
      case "confirmPassword":
        setPswdErrorMsg("");
        setPswdHelpText("");
        setConfirmPassword(e.target.value);
        // if (hasHitSubmit) validateConfirmPassword(e.target.value);
        break;
      default:
        break;
    }
  };

  return (
    <Grid
      item
      sx={{
        width: "100%",
        height: "100%",
        backgroundColor: "#FFFFFF",
        padding: "20px",
      }}>
      <Grid container sx={{ height: "100%", width: "100%" }}>
        <Grid item xs={12} md={6} sx={{ height: "100%" }}>
          <Grid
            container
            direction="column"
            sx={{
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "100%",
              overflowY: "auto",
            }}>
            <Grid
              item
              sx={{
                height: "auto",
                width: "350px",
                padding: "87px 0 87px 0",
              }}>
              <Grid
                container
                direction="column"
                sx={{
                  width: "100%",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}>
                {/* main Title */}
                <Grid
                  item
                  sx={{
                    width: "100%",
                    height: "30px",
                    marginBottom: "44px",
                  }}>
                  <Typography
                    sx={{
                      ...primaryTypographyStyles,
                      fontSize: 25,
                      fontWeight: 900,
                    }}>
                    Reset{" "}
                    <span style={{ ...secondaryTypographyStyles }}>
                      password
                    </span>
                  </Typography>
                </Grid>
                {/* form area */}
                <Grid
                  item
                  sx={{
                    width: "100%",
                    height: "auto",
                    marginBottom: "20px",
                  }}>
                  <Grid
                    container
                    direction="column"
                    sx={{
                      width: "100%",
                      height: "100%",
                      justifyContent: "space-between",
                      gap: "15px",
                    }}>
                    {/* email */}
                    <Grid
                      item
                      sx={{
                        width: "100%",
                        height: "75px",
                      }}>
                      <Typography
                        sx={{
                          color: "#A4A4A4",
                          fontFamily: "Lato",
                          fontSize: 14,
                          fontStyle: "normal",
                          fontWeight: 400,
                          lineHeight: "normal",
                          marginBottom: "10px",
                        }}>
                        Email
                      </Typography>
                      <Grid
                        item
                        sx={{
                          width: "100%",
                          height: "40px",
                        }}>
                        <InnoTextInput
                          fieldName="email"
                          placeholder="Your email"
                          fieldValue={email}
                          disabled={true}
                          width="100%"
                          height="40px"
                          styledProps={{
                            fontFamily: "Lato",
                            fontSize: "14px",
                            fontWeight: 700,
                            fontStyle: "normal",
                            color: "var(--Primary-900, #0B0926)",
                          }}
                          placeholderStyles={{
                            fontFamily: "Lato",
                            fontSize: "14px",
                            fontWeight: 700,
                            fontStyle: "normal",
                            color: "var(--Neutrals-700, #C6CCD2)",
                          }}
                          errorIcon={false}
                          feedbackError={false}
                          showErrorIconWithError={false}
                        />
                      </Grid>
                    </Grid>
                    {/* reset password */}
                    <Grid
                      item
                      sx={{ width: "100%", height: "67px" }}
                      className="password">
                      <RegistrationFormLabel id="password-label">
                        Password
                      </RegistrationFormLabel>
                      <TextBox
                        labelId="password-label"
                        value={password}
                        handleChange={(e) => handleChange(e, "password")}
                        fullWidth
                        type="password"
                        placeholder="***************"
                        customStyles={{
                          height: "40px",
                          border: "1.5px solid var(--Neutrals-500, #E2E6E9)",
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      sx={{ width: "100%", height: "67px" }}
                      className="confirm-password">
                      <RegistrationFormLabel id="confirm-password-label">
                        Re-enter Password
                      </RegistrationFormLabel>
                      <TextBox
                        labelId="confirm-password-label"
                        value={confirmPassword}
                        handleChange={(e) => handleChange(e, "confirmPassword")}
                        fullWidth
                        type="password"
                        placeholder="***************"
                        customStyles={{
                          height: "40px",
                          border: "1.5px solid var(--Neutrals-500, #E2E6E9)",
                        }}
                      />
                    </Grid>
                  </Grid>
                  {pswdErrorMsg && (
                    <Typography
                      sx={{
                        color: "var(--Errors-500, #C30930)",
                        fontFamily: "Lato",
                        fontSize: 12,
                        fontStyle: "normal",
                        fontWeight: 700,
                        lineHeight: "normal",
                        paddingLeft: "5px",
                        marginTop: "5px",
                      }}>
                      {pswdErrorMsg}
                    </Typography>
                  )}
                  {pswdHelpText}
                </Grid>
                {/* button area */}
                <Grid
                  item
                  sx={{
                    width: "100%",
                    height: "60px",
                    marginBottom: "20px",
                  }}>
                  <Grid
                    container
                    direction="column"
                    sx={{
                      width: "100%",
                      height: "100%",
                      justifyContent: "space-between",
                    }}>
                    {/* Email Button */}
                    <Grid
                      item
                      sx={{
                        width: "100%",
                        height: "60px",
                      }}>
                      <LabelButton
                        type="primary"
                        variant="contained"
                        text={"Login"}
                        function={handleResetPswd}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                {/* switch to login option */}
                <Grid
                  item
                  sx={{
                    width: "100%",
                    height: "17px",
                  }}>
                  <Typography
                    sx={{
                      color: "var(--Primary-500, #16124C)",
                      fontFamily: "Lato",
                      fontSize: 14,
                      fontStyle: "normal",
                      fontWeight: 400,
                      lineHeight: "normal",
                    }}>
                    Remember your password?{" "}
                    <span
                      style={{
                        color: "var(--Tertiary-500, #00A6FF)",
                        cursor: "pointer",
                      }}
                      onClick={handleToLoginPage}>
                      Login here
                    </span>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {/* If the screen size is extra small, do not show the image */}
        <Grid
          item
          xs={6}
          className="resetpswd-page-image"
          sx={{
            height: "100%",
            display: { xs: "none", md: "block" },
          }}>
          <img
            src="/images/Product_registration-01.png"
            alt="resetpswd"
            className="registration-image"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center",
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}

function RegistrationFormLabel({ id, children }) {
  return (
    <Typography
      sx={{
        color: "#A4A4A4",
        fontFamily: "Lato",
        fontSize: 14,
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "normal",
        marginBottom: "10px",
      }}>
      {children}
    </Typography>
  );
}

function pswdHelpTextList(index, msg, hasError) {
  return (
    <ListItem
      key={index}
      disableGutters
      sx={{ paddingY: "1px" }} // Adjust vertical spacing between items
    >
      <ListItemIcon sx={{ minWidth: 12 }}>
        <Typography
          component="span"
          sx={{
            color: hasError ? "#F5325B" : "#2E7D32",
            fontFamily: "Lato",
            fontSize: 10,
            fontStyle: "normal",
            fontWeight: "regular",
            lineHeight: "normal",
          }}>
          •
        </Typography>
      </ListItemIcon>
      <ListItemText
        primary={msg}
        sx={{
          marginTop: 0,
          marginBottom: 0,
        }}
        primaryTypographyProps={{
          sx: {
            color: hasError ? "#F5325B" : "#2E7D32",
            fontFamily: "Lato",
            fontSize: 10,
            fontStyle: "normal",
            fontWeight: "regular",
            lineHeight: "normal",
            textTransform: "none",
          },
        }}
      />
    </ListItem>
  );
}
